import { render, staticRenderFns } from "./JobSearchCard.vue?vue&type=template&id=8d23d3bc&scoped=true&"
import script from "./JobSearchCard.vue?vue&type=script&lang=js&"
export * from "./JobSearchCard.vue?vue&type=script&lang=js&"
import style0 from "./JobSearchCard.vue?vue&type=style&index=0&id=8d23d3bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d23d3bc",
  null
  
)

export default component.exports